import React from 'react'

import {
  AccessLevelSelect,
  AccessLevelSelectOption,
  AccessLevelSelectProps,
  ParentAccessLevel,
} from '@sketch/modules-common'

export const ParentPermissionsAccessSelect = ({
  level,
  setLevel,
  hideCommentLabel,
}: AccessLevelSelectProps<ParentAccessLevel, ParentAccessLevel>) => (
  <AccessLevelSelect
    level={level}
    setLevel={(value: ParentAccessLevel) => setLevel(value)}
    commentsEnabled={true}
    hideCommentLabel={hideCommentLabel}
  >
    <AccessLevelSelectOption
      data-testid="access-level-dropdown-view"
      level="VIEW"
      label="View"
      help="View document in the web app"
    />
    <AccessLevelSelectOption
      data-testid="access-level-dropdown-edit"
      level="DEFAULT"
      label="Default"
      help="Workspace Editors can edit and Viewers can inspect"
    />
  </AccessLevelSelect>
)
